import React, { useState, useEffect } from 'react';
import {Input, Alert, Table} from 'reactstrap';
import axios from "axios";
import { Col, Row, Card, Form, Button } from 'react-bootstrap';
//import { phoneCode } from '../../ProData';
import ProfileImage from './ProfileImage';
import Guidelines from './Guidelines';
//import Preloader from './shared/Preloader';
const config = require('../../config.json');
const defaultAvatar = require("../../assets/defaultAvatar.jpg")
const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;


export default function ApplicationForm () {
    const [applicant, setApplicant]=useState({applicationNo:'',applicantName:'', applicantContactNo:'', applicantEmailID:'', applicantAreaCode:'+91', applicantAddress:'', institutionName:'',
    institutionAddress:'', institutionAreaCode:'+91', institutionContactNo:'', institutionEmailID:'', researchProjectTitle:'', materialRequired:[], guideName:'', guideDesignation:'', guideAddress:'', guideContactNo:'',  guideAreaCode:'+91', guideEmailID:'',
    applicationStatus:'', registrationDate:'', updatedBy:'', updatedOn:''});
    const [alertDetails, setAlertDetails] = useState({style:"", open:false, message:""});
    const [profileImage, setProfileImage] = useState(defaultAvatar);
    const [imageFile, setImageFile] = useState('');
    const [loaded, setLoaded] = useState(true);
    const [emailCodeReceived, setEmailCodeReceived] = useState('');
    const [emailCodeEntered, setEmailCodeEntered]= useState('')
    const [isEmailValidated, setIsEmailValidated]=useState(false);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false);
    const [applicationProcessed, setApplicationProcessed]=useState(false);
    const [app, setApp]=useState({appNo:'', appMsg:''});
    const [materialsRequired, setMaterialsRequired]= useState({item:''});
    const [guidelinesAcknowledged, setGuidelinesAcknowledged] = useState(false);

      useEffect(()=>{
          resetValues();
          setProfileImage(defaultAvatar);
          document.title = "Application Form - Jesuit Madurai Province Archives (JEMPARC)";
          window.scrollTo(0, 0);
          document.body.classList.add('application');
          //console.log("Courses Option : ", sortedArray);
      },[])

      const generateApplicationNo=()=>{
        const current_datetime = new Date();
        //const fName=applicant.applicantName.trim().replace(/\s/g, "");
        //const tusername=memberInfo.name.trim().replace(/\s/g, "");
        //const tfName= fName.substring(0,2).toUpperCase();
        //const lName=form.lastName.trim().replace(/\s/g, "");
        //const tusername=memberInfo.name.trim().replace(/\s/g, "");
        //const tlName= lName.substring(0,2).toUpperCase();
        var tempUserId="";
        const date_year = (current_datetime.getFullYear()).toString().substring(2,4);
        var date_month = (current_datetime.getMonth() + 1).toString();
        var month_value="";
        date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
        var date_date = (current_datetime.getDate().toString());
        var date_value="";
        date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
        var date_hours = (current_datetime.getHours().toString());
        var hours_value="";
        date_hours.length===1?(hours_value=hours_value.toString().concat(0,date_hours)):(hours_value=date_hours);
        var date_minutes = (current_datetime.getMinutes().toString());
        var minutes_value="";
        date_minutes.length===1 ?(minutes_value=minutes_value.toString().concat(0,date_minutes)):(minutes_value=date_minutes);
        const accountNo = tempUserId.concat(date_year,month_value, date_value, hours_value, minutes_value);
        //setUserId(accountNo);
        //setMemberInfo({...memberInfo, userId:accountNo});
        return accountNo;
        //console.log("acc : ", accountNo);
      
      }
  
      const generateDate=()=>{
      const current_datetime = new Date();
      var tempUserId="";
      const date_year = (current_datetime.getFullYear()).toString();
      var date_month = (current_datetime.getMonth() + 1).toString();
      var month_value="";
      date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
      var date_date = (current_datetime.getDate().toString());
      var date_value="";
      date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
      var date_hours = (current_datetime.getHours().toString());
      var hours_value="";
      date_hours.length===1?(hours_value=hours_value.toString().concat(0,date_hours)):(hours_value=date_hours);
      var date_minutes = (current_datetime.getMinutes().toString());
      var minutes_value="";
      date_minutes.length===1 ?(minutes_value=minutes_value.toString().concat(0,date_minutes)):(minutes_value=date_minutes);
      const accountNo = tempUserId.concat(date_year,"-",month_value,"-", date_value);
      //setUserId(accountNo);
      //setMemberInfo({...memberInfo, userId:accountNo});
      return accountNo;
      //console.log("acc : ", accountNo);
    
      }

      const resetValues=()=>{
        setApplicant({...applicant,applicationNo:'',applicantName:'', applicantContactNo:'', applicantEmailID:'', applicantAreaCode:'+91', applicantAddress:'', institutionName:'',
        institutionAddress:'', institutionAreaCode:'+91', institutionContactNo:'', institutionEmailID:'', researchProjectTitle:'', materialRequired:[], guideName:'', guideDesignation:'', 
        guideAddress:'', guideAreaCode:'+91', guideContactNo:'', guideEmailID:'', applicationStatus:'', registrationDate:'', updatedBy:'', updatedOn:''});
        //setImageFile('');
        setEmailCodeEntered('');
        setEmailCodeReceived('');
        //setEmailValidated(false);
        setIsEmailValidated(false);
        setIsFormSubmitted(false);
        //initializeValues();
      }

      const handleEmailValidation=async(event)=>{
        event.preventDefault();
        try{

          const validationResult=validateFields();
          if(validationResult==="passed"){
          setLoaded(false);
              //const clientID="VJDEPTH";
              await axios.get(`${config.api.invokeURL}/form/registration/emailvalidation?emailID=${applicant.applicantEmailID}`,{
                  headers: {
                   // Authorization: access_token,
                    'x-api-key': config.api.key
                  }}, 
              ).then((response)=>{
                //console.log(response);
                if(response.status===200){
                  setEmailCodeReceived(response.data);
                  //setEmailValidated(true);
                  setIsEmailValidated(true);
                  setAlertDetails({
                    ...alertDetails,
                    style:"success",
                    open:true,
                    message: "One Time password has been sent to your email addresss"
                });  
                window.scrollTo(0,0);
                }else{
                  setAlertDetails({
                    ...alertDetails,
                    style:"warning",
                    open:true,
                    message: "Duplicate Records Found!"
                });  
                window.scrollTo(0,0);
                }
                  setLoaded(true);
              }).catch((error)=>{
                  //console.log(error);
                  setAlertDetails({
                      ...alertDetails,
                      style:"warning",
                      open:true,
                      message:"Error Occured - " + error.message
                  }); 
                  window.scrollTo(0,0);
                  setLoaded(true);
              })
            }
        }catch(error){
          setLoaded(true);
            setAlertDetails({
              ...alertDetails,
              style:"warning",
              open:true,
              message: "Error Occured : " + error.message
          });                 
          window.scrollTo(0,0);
      
        }
      }

      const validateFields=()=>{
        const {applicationNo,applicantName, applicantContactNo, applicantEmailID, applicantAreaCode, applicantAddress, institutionName,
        institutionAddress, institutionContactNo, institutionEmailID, researchProjectTitle, materialRequired, guideName, guideDesignation, guideAddress, guideContactNo, guideEmailID}=applicant;
          var returnValue="passed";
          /*if(applicationNo===""){
            setAlertDetails({
              ...alertDetails,
              style:"warning",
              open:true,
              message: "Applicant Number cannot be Empty! Refresh the page and try again!"
          }); 
          returnValue="failed";
        }else */if(applicantName===""){
          setAlertDetails({
            ...alertDetails,
            style:"warning",
            open:true,
            message: "Full Name cannot be Empty"
        }); 
        returnValue="failed";
      }else if(applicantContactNo===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Applicant Contact Number cannot be Empty"
      }); 
      returnValue="failed";
      }else if(applicantEmailID===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Applicant Email ID cannot be Empty"
      }); 
      returnValue="failed";
      }else if(applicantAreaCode===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Applicant Area Code cannot be Empty"
      }); 
      returnValue="failed";
      }else if(applicantAddress===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Applicant Address cannot be Empty"
      }); 
      returnValue="failed";
      }else if(institutionName===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Institution Name cannot be Empty"
      }); 
      returnValue="failed";
      }else if(institutionAddress===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Institution Address cannot be Empty"
      }); 
      returnValue="failed";
      }else if(!applicantEmailID.match(validRegex)){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Applicant Email address is not in right format!"
      }); 
      returnValue="failed";
      }else if(institutionContactNo===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Institution Contact Number cannot be Empty"
      }); 
      returnValue="failed";
      }else if(institutionEmailID===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Institution Email ID cannot be Empty"
      }); 
      returnValue="failed";
      }else if(!institutionEmailID.match(validRegex)){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Institution Email address is not in right format!"
      }); 
      returnValue="failed";
      }else if(researchProjectTitle===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Research Title cannot be Empty"
      }); 
      returnValue="failed";
      }else if(materialRequired.length<1){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Materials Required cannot be Empty"
      }); 
      returnValue="failed";
      }else if(guideName===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Guide Name cannot be Empty"
      }); 
      returnValue="failed";
      }else if(guideDesignation===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Guide Designation cannot be Empty"
      }); 
      returnValue="failed";
      }else if(guideAddress===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Guide Address cannot be Empty"
      }); 
      returnValue="failed";
      }else if(guideContactNo===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Guide Contact No cannot be Empty"
      }); 
      returnValue="failed";
      }else if(guideEmailID===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Guide Email ID cannot be Empty"
      }); 
      returnValue="failed";
      }else if(!guideEmailID.match(validRegex)){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Guide Email address is not in right format!"
      }); 
      returnValue="failed";
      }else  if(imageFile===""){
        setAlertDetails({
          ...alertDetails,
          style:"warning",
          open:true,
          message: "Attach your Photo. Photo is must for registration!"
      }); 
      returnValue="failed";
      }else {
      returnValue="passed";
      }
      window.scrollTo(0,0);
      return returnValue;
      }

      const handleNewForm=()=>{
        resetValues();
        setApp({...app, appNo:'', appMsg:''});
        setApplicationProcessed(false);
        alertClose();
      }

      const alertClose=()=>{
        setAlertDetails({
            ...alertDetails,
            style:"",
            open:false,
            message:""
        });
      }
      
      const handleSubmit=async(event)=>{
          event.preventDefault();
          try{
          alertClose();
          //  console.log("value : ", emailCodeEntered, emailCodeReceived);
          const temailcodeentered=emailCodeEntered.toString();
          const temailcodereceived=emailCodeReceived.toString();
          if(temailcodeentered===temailcodereceived){
              setLoaded(false);
              const {applicantName, applicantContactNo, applicantEmailID, applicantAreaCode, applicantAddress, institutionName,
              institutionAddress, institutionAreaCode, institutionContactNo, institutionEmailID, researchProjectTitle, materialRequired, 
              guideName, guideDesignation, guideAddress, guideAreaCode, guideContactNo, guideEmailID}=applicant;
          const clientID = "ARCHIVE";
          const applicationno= await generateApplicationNo();
          const applicationDate=await generateDate();
          const applicationStatus="Pending Approval";
          const avatar= applicationno+".jpeg";
          const params={
              clientID:clientID, applicationNo: applicationno, applicantName:applicantName, applicationDate: applicationDate, applicationStatus:applicationStatus,
              applicantContactNo:applicantContactNo, applicantEmailID:applicantEmailID, applicantAreaCode:applicantAreaCode, applicantAddress:applicantAddress,
              institutionName:institutionName, institutionAddress:institutionAddress, institutionAreaCode:institutionAreaCode, institutionContactNo:institutionContactNo, institutionEmailID:institutionEmailID, 
              researchProjectTitle:researchProjectTitle, materialRequired:materialRequired, guideName:guideName, guideDesignation:guideDesignation, guideAddress:guideAddress, guideAreaCode:guideAreaCode,
              guideContactNo:guideContactNo, guideEmailID:guideEmailID, avatar:avatar, updatedBy:applicationno, updatedOn:applicationDate, registrationDate:applicationDate, 
              startDate:"NA", endDate:"NA", specialAccess:"No", comments:"NA", requestID:applicationno, requestStatus:applicationStatus, requestDate:applicationDate};
          //console.log("Params : ", params);
          await axios.post(`${config.api.invokeURL}/form/registration/${applicationno}`, params,{
              headers: {
              //  Authorization: access_token,
              'x-api-key':config.api.key
              }})
              .then(async(response)=>{
              //   console.log("response : ", response); 
              await postOnS3(applicationno, imageFile,"Profile");
              //await postOnS3(applicationno, idProofFile,"IDProof");
              //await postOnS3(applicationno, certProofFile,"CERTProof");
              setApplicationProcessed(true);
              setApp({...app, appNo:applicationno, appMsg:"Congratulations and Thank you for showing interest in our archive program!!! Your Registration is successful. Your application will be reviewed throughly and further updates will be shared via Email. You can also get the latest updates from our portal."})
              setAlertDetails({
                  ...alertDetails,
                  style:"success",
                  open:true,
                  message: applicationno + " - Successfully Registered."
              }); 
              window.scrollTo(0,0);
              resetValues();
              setLoaded(true);
              }).catch((error)=>{
              //   console.log("error : ", error);
                  setAlertDetails({
                  ...alertDetails,
                  style:"warning",
                  open:true,
                  message: "Error Occured : " + error.message
              }); 
              window.scrollTo(0,0);
              setLoaded(true);
              })
          }else{
              setAlertDetails({
              ...alertDetails,
              style:"warning",
              open:true,
              message: "Incorrect OTP Entered! Try Again!!!"
          }); 
          window.scrollTo(0,0);
          setLoaded(true);
          }
          }catch(error){
      //      console.log("error : ", error);
          setAlertDetails({
              ...alertDetails,
              style:"warning",
              open:true,
              message:"Error Occured - " + error.message
          }); 
          window.scrollTo(0,0);
          setLoaded(true);
          }
      }

      const postOnS3 = async(applicationno,timageFile,inputType)=>{
        try{
            //  console.log("NewImage : ", newImage);
            var tKeyName="";
            var newFileName="";
            if(inputType==="Profile"){
              tKeyName="avatar/"+applicationno;   
              newFileName=applicationno+".jpeg";
            }else if (inputType==="IDProof"){
              tKeyName="avatar/"+applicationno+"/docs";  
              newFileName=applicationno+"_idproof.jpeg"; 
            }else if (inputType==="CERTProof"){
              tKeyName="avatar/"+applicationno+"/docs";  
              newFileName=applicationno+"_certproof.jpeg"; 
            }   
          
          //console.log("newfilename :", newFileName);
         // const newImage="";
          var file = timageFile;
          var blob = file.slice(0, file.size, 'image/jpeg'); 
          const newFile = new File([blob], newFileName, {type: 'image/jpeg'});
         // console.log("New file : ", newFile);
         // const session = await Auth.currentSession();
         // const access_token=session.idToken.jwtToken;
          const bucketName=config.s3.bucketName + tKeyName;
         // await axios.get(`${config.api.invokeUrl}/profile_avatar/presigned/uploader?fileName=${newFileName}&bucketName=${bucketName}`,{
         // await axios.get(`${config.api.invokeURL}/images/gallery/newgallery?fileName=${newFileName}&bucketName=${bucketName}&keyName=${newKeyName}`,{
          await axios.get(`${config.api.invokeURL}/dashboard/images/gallery/newgallery?fileName=${newFileName}&bucketName=${bucketName}`,{
               headers:{
           //        Authorization: access_token,
                   'x-api-key': config.api.key
               }
           }).then(async(response)=>{
             //  console.log("Response : ", response);
              const res=await fetch(response.data.uploadURL, { method: 'PUT',
               headers:{
                   "Content-Type":"image/jpeg"
                 },body: newFile});
               //  console.log("Res : ", res);
                 if(res.status===200){
                //  setNewProfileImage(newFileName);
                  //  fetchGalleryImages();
                    // setProfileImage(newFileName);
                     //var timestamp = new Date().getTime();     
                    // var tprofile = document.getElementById("profile");
                     //var imgsrc="";
                     //imgsrc=imgsrc.concat(config.s3.imageURL,newFileName,"?t=",timestamp);     
                     //tprofile.src=`${config.s3.imageURL}${newFileName}`+"?t="+timestamp;
                    // tprofile.src=imgsrc;
                    //tprofile.src="https://s3.ap-south-1.amazonaws.com/idntica.com/avatar/profileImage/defaultAvatar.jpeg";
                     //console.log("tprofle : ", tprofile.src);
                 }
            }).catch((error)=>{
               // console.log("error1:", error);
                setAlertDetails({
                    ...alertDetails,
                    style:"warning",
                    open:true,
                    message:"Error Occured - " + error.message
                }); 
             // setDispMsg(error.message);
             // hideLoader();
           })
        
        }catch(error){
         // console.log("error1:", error);
          setAlertDetails({
            ...alertDetails,
            style:"warning",
            open:true,
            message:"Error Occured - " + error.message
        }); 
        } 
      }    

      const handleMaterialsAdd =async(event)=>{
          event.preventDefault();
          if(materialsRequired.item===""){
            setAlertDetails({
              ...alertDetails,
              style:"warning",
              open:true,
              message:"Materials Required cannot be empty"
          }); 
          }else{
            //setStudyDetails([...studyDetails, localStudy]);
            await setApplicant({...applicant,
              materialRequired:[...applicant.materialRequired, materialsRequired]});
              setMaterialsRequired({item:''});
            //   calculateProgressiveValues(memberInfo);
          }
      }

  return (
    <div>
      <section id="about" className="about section">
      <div className="container section-title" data-aos="fade-up">
          <h2>Application</h2>
          <p>Guidelines & Application Form</p>
        </div>
   
    {/*<Preloader show={loaded ? false : true} />*/}
    <Alert color={alertDetails.style} fade={true} isOpen={alertDetails.open} toggle={alertClose} >
         {alertDetails.message}
    </Alert>
    {!guidelinesAcknowledged ?
    <Guidelines setGuidelinesAcknowledged={setGuidelinesAcknowledged} />
        :<>

   {!isEmailValidated?  
   <Card border="light" className=" bg-white shadow-sm mb-4">
    <Card className="container">  
    <ProfileImage fileName="test" setProfileImage={setProfileImage} profileImage={profileImage} alertDetails={alertDetails} setAlertDetails={setAlertDetails} setImageFile={setImageFile}/>
   
    <strong style={{textAlign:"left"}}>Applicant Details:</strong>
    <Card className="container">     
        <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="title">
                <Form.Label>Full Name</Form.Label>
                <Form.Control required type="text" placeholder="Enter your Full name" 
                value={applicant.applicantName} onChange={(event)=>{setApplicant({...applicant, applicantName:event.target.value})}}/>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="title">
                <Form.Label>Email ID</Form.Label>
                <Form.Control required type="text" placeholder="Enter your Email Address" 
                value={applicant.applicantEmailID} onChange={(event)=>{setApplicant({...applicant, applicantEmailID:event.target.value})}}/>
              </Form.Group>
            </Col>
            </Row>
            <Row>
        <Col sm={6} className="mb-3">
              <Form.Group id="areanumber">
                <Form.Label>Contact No</Form.Label>
                <Row>
                <Col sm={2}>
            <Input type="select" name="courseName"
                                  value={applicant.applicantAreaCode} 
                                  onChange={(event)=>{setApplicant({...applicant, applicantAreaCode:(event.target.value)})}}
                                >
                                  {/*phoneCode.map(item => {
                                return (<option key={item.Code} value={item.Code}>{item.Code}</option>);
                              })*/}
                  </Input>
            </Col>
            <Col sm={10}>
            <Form.Control required type="number" placeholder="Enter your Contact number" 
                value={applicant.applicantContactNo} onChange={(event)=>{setApplicant({...applicant, applicantContactNo:event.target.value})}}/>
            </Col>
                </Row>               
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="title">
                <Form.Label>Address</Form.Label>
                <Form.Control required type="text" placeholder="Enter your Full Address" 
                value={applicant.applicantAddress} onChange={(event)=>{setApplicant({...applicant, applicantAddress:event.target.value})}}/>
              </Form.Group>
            </Col>
            </Row>
    </Card>
    <strong style={{textAlign:"left"}}>Institution Details:</strong>
    <Card className="container">     
    <Row>
        <Col md={6} className="mb-3">
            <Form.Group id="institution">
            <Form.Label>Institution Name</Form.Label>
            <Form.Control required type="text" placeholder="Enter Institution Full name" 
            value={applicant.institutionName} onChange={(event)=>{setApplicant({...applicant, institutionName:event.target.value})}}/>
            </Form.Group>
        </Col>
        <Col md={6} className="mb-3">
            <Form.Group id="title">
            <Form.Label>Email ID</Form.Label>
            <Form.Control required type="text" placeholder="Enter Institution Email Address" 
            value={applicant.institutionEmailID} onChange={(event)=>{setApplicant({...applicant, institutionEmailID:event.target.value})}}/>
            </Form.Group>
        </Col>
        </Row>
        <Row>
        <Col sm={6} className="mb-3">
              <Form.Group id="areanumber">
                <Form.Label>Institution Contact No</Form.Label>
                <Row>
                <Col sm={2}>
            <Input type="select" name="institutionContactNo"
                                  value={applicant.institutionAreaCode} 
                                  onChange={(event)=>{setApplicant({...applicant, institutionAreaCode:(event.target.value)})}}
                                >
                                  {/*phoneCode.map(item => {
                                return (<option key={item.Code} value={item.Code}>{item.Code}</option>);
                              })*/}
                  </Input>
            </Col>
            <Col sm={10}>
            <Form.Control required type="number" placeholder="Enter Institution Contact number" 
                value={applicant.institutionContactNo} onChange={(event)=>{setApplicant({...applicant, institutionContactNo:event.target.value})}}/>
            </Col>
                </Row>               
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
            <Form.Group id="title">
            <Form.Label>Address</Form.Label>
            <Form.Control required type="text" placeholder="Enter Institution Full Address" 
            value={applicant.institutionAddress} onChange={(event)=>{setApplicant({...applicant, institutionAddress:event.target.value})}}/>
            </Form.Group>
        </Col>
        </Row>
    </Card>
    <strong style={{textAlign:"left"}}>Guide Details:</strong>
    <Card className="container">     
    <Row>
        <Col md={6} className="mb-3">
            <Form.Group id="gname">
            <Form.Label>Guide Name</Form.Label>
            <Form.Control required type="text" placeholder="Enter your Guide name" 
            value={applicant.guideName} onChange={(event)=>{setApplicant({...applicant, guideName:event.target.value})}}/>
            </Form.Group>
        </Col>
        <Col md={6} className="mb-3">
            <Form.Group id="gdesignation">
            <Form.Label>Guide Designation</Form.Label>
            <Form.Control required type="text" placeholder="Enter your Guide Designation" 
            value={applicant.guideDesignation} onChange={(event)=>{setApplicant({...applicant, guideDesignation:event.target.value})}}/>
            </Form.Group>
        </Col>
        </Row>
        <Row>
       {/*} <Col md={6} className="mb-3">
            <Form.Group id="gcontactNo">
            <Form.Label>Guide Contact No</Form.Label>
            <Form.Control required type="text" placeholder="Enter your Guide Contact Number" 
            value={applicant.guideContactNo} onChange={(event)=>{setApplicant({...applicant, guideContactNo:event.target.value})}}/>
            </Form.Group>
                            </Col>*/}
        <Col sm={6} className="mb-3">
              <Form.Group id="areanumber">
                <Form.Label>Guide Contact No</Form.Label>
                <Row>
                <Col sm={2}>
            <Input type="select" name="guideContactNo"
                                  value={applicant.guideAreaCode} 
                                  onChange={(event)=>{setApplicant({...applicant, guideAreaCode:(event.target.value)})}}
                                >
                                  {/*phoneCode.map(item => {
                                return (<option key={item.Code} value={item.Code}>{item.Code}</option>);
                              })*/}
                  </Input>
            </Col>
            <Col sm={10}>
            <Form.Control required type="number" placeholder="Enter Guide Contact number" 
                value={applicant.guideContactNo} onChange={(event)=>{setApplicant({...applicant, guideContactNo:event.target.value})}}/>
            </Col>
                </Row>               
              </Form.Group>
            </Col>
       
        <Col md={6} className="mb-3">
            <Form.Group id="gamilid">
            <Form.Label>Guide Email ID</Form.Label>
            <Form.Control required type="text" placeholder="Enter your Guide Email Address" 
            value={applicant.guideEmailID} onChange={(event)=>{setApplicant({...applicant, guideEmailID:event.target.value})}}/>
            </Form.Group>
        </Col>
        </Row>
        <Row>
        <Col md={6} className="mb-3">
            <Form.Group id="gaddress">
            <Form.Label>Guide Address</Form.Label>
            <Form.Control required type="text" placeholder="Enter your Guide Full Address" 
            value={applicant.guideAddress} onChange={(event)=>{setApplicant({...applicant, guideAddress:event.target.value})}}/>
            </Form.Group>
        </Col>
        </Row>
    </Card>
    <strong style={{textAlign:"left"}}>Research Details:</strong>
    <Card className="container">     
    <Row>
        <Col md={12} className="mb-3">
            <Form.Group id="rname">
            <Form.Label>Research Name</Form.Label>
            <Form.Control required type="text" placeholder="Enter your Research name" 
            value={applicant.researchProjectTitle} onChange={(event)=>{setApplicant({...applicant, researchProjectTitle:event.target.value})}}/>
            </Form.Group>
        </Col>
        </Row>
        <Row>
        <Col md={9} className="mb-3">
            <Form.Group id="materials">
            <Form.Label>Materials Required:</Form.Label>
            <Form.Control required type="text" placeholder="Enter material details" 
            value={materialsRequired.item} onChange={(event)=>{setMaterialsRequired({...materialsRequired, item:event.target.value})}}/>
            </Form.Group>
        </Col>
        <Col md={3} className="mb-3">
        <Form.Group id="addbutton">
            <Form.Label>   </Form.Label>
        <Button onClick={event=>handleMaterialsAdd(event)}>Add</Button>
        </Form.Group>
        </Col>
    </Row>
    <Table hover responsive>
  <thead>
    <tr>
      <th>
        #
      </th>
      <th>
       Materials
      </th>
    </tr>
  </thead>
  <tbody>
  {applicant.materialRequired && applicant.materialRequired.map((item, index)=>
    <tr key={index}>
      <th scope="row">
      {index+1}

      </th>
      <td>
      {item.item}
      </td>
       {/*!viewOnly? <td>
      <FontAwesomeIcon icon={faTrash} className="me-2" onClick={(event)=>{handleRemoveStudy(event, item)}}/>
  </td>:null*/}
    </tr>)}
  </tbody>
</Table>
    <Row>

    </Row>
    </Card>
    <Button onClick={event=>handleEmailValidation(event)}>Submit</Button>
    </Card>
    </Card>:null}

    {!isFormSubmitted && isEmailValidated ? 
    <Card border="light" className="container  shadow-sm mb-4 d-flex mx-auto">
      <Card.Body className="text-center justify-content-center mx-auto">     
        <h5 className="mb-4">Registration - Validation</h5>
        <Form className="text-center justify-content-center ">
        <Alert color={alertDetails.style} fade={true} isOpen={alertDetails.open} toggle={alertClose} >
        {alertDetails.message}
        </Alert>
        <div className="m-3 " >
           <Row className="justify-content-center text-center">
        <Form.Group id="otp">
                <Form.Label>Enter the One Time Password</Form.Label>
                <Form.Control required type="text" placeholder="Enter OTP" 
                value={emailCodeEntered} onChange={(event)=>{setEmailCodeEntered(event.target.value)}}/>
              </Form.Group>
        </Row>
        <div className="mt-3 text-center">
            <Button className="m-3" variant="primary" type="submit" onClick={(event)=>{handleSubmit(event)}}>Validate OTP</Button>
            <Button variant="primary" type="submit" onClick={(event)=>{handleEmailValidation(event)}}>Resend OTP</Button>

          </div>
        </div>
       

        </Form>
        </Card.Body>
     </Card>:null}

     {applicationProcessed && isFormSubmitted ? <Card border="light" className=" container bg-white shadow-sm mb-4">
      <Card.Body>     
        <h5 className="mb-4">Registration - Final Status</h5>
        <Form>
        <Alert color={alertDetails.style} fade={true} isOpen={alertDetails.open} toggle={alertClose} >
        {alertDetails.message}
        </Alert>
        <Row>
        <h3 className="mb-4">Registration No - {app.appNo}</h3>
        </Row>
        <Row>
          <p>{app.appMsg}</p>
        </Row>
        <div className="mt-3 text-center">
            <Button variant="primary" type="submit" onClick={(event)=>{handleNewForm(event)}}> New Form</Button>

          </div>

        </Form>
        </Card.Body>
     </Card>:null}
     </>}
     </section>
               </div>
  )
}
